module.exports = __webpack_public_path__ + "static/img/2712_phase_function_Paper_PointsHejduk_Prediction.79f77d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2712_phase_function_Paper_PointsHejduk_Prediction.png
// module id = W2in
// module chunks = 0